import React, { useState } from "react";
import "./CallMe.css";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";

import {
  DialogContent,
  FormControl,
  TextField,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  Tabs,
  Tab,
  DialogActions,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { StaticDateTimePicker } from "@mui/x-date-pickers/StaticDateTimePicker";
import dayjs, { Dayjs } from "dayjs";
import { useTheme } from '@mui/material/styles'; // Import useTheme from MUI
import { countries, CountryType } from "../../../utils/countries.details";
import { callBackAPI } from "../../../utils/constants";

export interface SimpleDialogProps {
  open: boolean;
  onClose: (value: string) => void;
}

const CallMe: React.FC<SimpleDialogProps> = ({ open, onClose }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedCode, setSelectedCode] = useState<string>("+91");
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [isValid, setIsValid] = useState(false);
  const [openTimeSlot, setOpenTimeSlot] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(dayjs());
  const [tabValue, setTabValue] = useState("calendar");

  const theme = useTheme(); // Access the current theme

  const handleCallMe = () => {
    if (validatePhoneNumber()) {
      console.log("phone number", selectedCode + "-" + phoneNumber);
      callBackAPIFunction(null);
      setMessage('You will receive a call shortly. Please wait...');
      setTimeout(() => handleClose(), 4000);
    }

    // setOpen(false);
  };

  const handleDateChange = (newVal: any) => {
    setSelectedDate(newVal);
    console.log(newVal.format());
  };

  const handleTabChange = (event: any, newValue: any) => {
    console.log("mew valie", newValue);
    setTabValue(newValue);
  };

  const handleScheduleCall = () => {
    if (validatePhoneNumber()) {
      console.log("phone number", selectedCode + "-" + phoneNumber);
      callBackAPIFunction(selectedTime?.format("YYYY-MM-DDTHH:mm:ssZ"));
      setMessage('Your call has been scheduled, and you will receive it at the specified time.');
      setTimeout(() => handleClose(), 4000);
    }
  };

  const callBackAPIFunction = async (callbackTime: any) => {
    try {
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          {
            "phoneNumber": phoneNumber,
            "userName": "test",
            "callbackTime": callbackTime,
            "email": "test@tcs.com"
          }
        )
      };
      const result: any = await (await fetch(callBackAPI, options)).json();
      return result;
    } catch (err) {
      console.log('ERROR :::', err);
      return false;
    }
  }

  const validatePhoneNumber = (): boolean => {
    const country = countries.find((c: CountryType) => c.phone === selectedCode.split('+')[1]);
    if (country) {
      const countryPhoneLength = country.length;
      const result = phoneNumber.length === countryPhoneLength;
      if (result) {
        setError(null);
        setIsValid(result);
      } else {
        setError('Please enter valid mobile number.')
        setIsValid(result)
      }
      return result
    } else {
      return false;
    }
  }

  const handleCodeChange = (e: any) => {
    console.log("code change", e.target.value);
    setSelectedCode(e.target.value);
  };

  const handleClose = () => {
    setMessage(null);
    onClose("false");
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px",
            backgroundColor: "#1976d2",
            borderRadius: "24px", // Set your width here
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px",
            padding: "16px",
          },
        }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="closeBtn" onClick={handleClose}>
            <i
              style={{ display: "flex", fontSize: "28px" }}
              className="bi bi-x"
            ></i>
          </div>
        </div>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "24px 24px 0px 0px",
          backgroundColor: theme.palette.mode === 'dark' ? "#121212" : "#fff",
          gap: "12px",
          padding: "0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            gap: "10px",
          }}
        >
          <button
            className="btn btn-outline-primary"
            style={{
              backgroundColor: openTimeSlot ? "#1976d2" : "",
              color: openTimeSlot ? "white" : "",
              borderRadius: "50px",
              width: "fit-content",
              fontSize: "12px",
              display: "flex",
              gap: "4px",
              alignItems: "center",
              padding: "8px",
            }}
            onClick={() => {
              setOpenTimeSlot((prevState) => !prevState);
            }}
          >
            <div style={{ width: "21px" }}>
              <i
                className="bi bi-telephone-plus"
                style={{ fontSize: "14px" }}
              ></i>
            </div>
            <p className="call-me-btns">Schedule a Call</p>
          </button>

          <button
            className="btn btn-outline-primary"
            style={{
              // backgroundColor: "#f8fcff",
              // backgroundColor: '',
              // color: "#1976d2",
              borderRadius: "50px",
              width: "fit-content",
              fontSize: "12px",
              // border: "1px solid #1976d2",
              display: "flex",
              gap: "4px",
              alignItems: "center",
              padding: "8px",
            }}
            onClick={handleClose}
          >
            <div style={{ width: "21px" }}>
              <i className="bi bi-headset" style={{ fontSize: "14px" }}></i>
            </div>
            <p className="call-me-btns">Chat with Agent</p>
          </button>
        </div>
        <div style={{ overflowY: "auto" }}>
          <div style={{ padding: "0px 16px 16px" }}>
            <div className="logoWrapper">
              <div className="botLogo"></div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                // marginTop: "34px",
                // padding: "16px",
              }}
            >
              <div
                style={{
                  paddingLeft: "8px",
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Enter your phone number for agent to call you with
              </div>
              <div
                style={{
                  display: "flex",

                  width: "100%",
                }}
              >
                <FormControl variant="outlined" sx={{ m: 1, minWidth: 100 }}>
                  <Select
                    value={selectedCode}
                    onChange={handleCodeChange}
                    renderValue={(selected) => selected || "Select Code"}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                          width: 250,
                        },
                      },
                    }}
                    displayEmpty
                  >
                    {countries.map((country) => (
                      <MenuItem key={country.code} value={`+${country.phone}`}>
                        {country.label} (+{country.phone})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  autoFocus
                  margin="dense"
                  variant="outlined"
                  id="phone"
                  placeholder="Enter your Number"
                  type="tel"
                  fullWidth
                  value={phoneNumber}
                  error={!!error}
                  helperText={error}
                  InputProps={{
                    endAdornment: isValid && (
                      <InputAdornment position="end">
                        <div
                          style={{
                            width: "28px",
                            height: "28px",
                            display: "flex",
                          }}
                        >
                          <i
                            style={{
                              fontSize: "28px",
                              width: "28px",
                              backgroundColor: "#58d274",
                              color: "white",
                              borderRadius: "50px",
                            }}
                            className="bi bi-check"
                          ></i>
                        </div>
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                    validatePhoneNumber()
                    // setError(null);
                    // setIsValid(validatePhoneNumber());
                  }}
                />
              </div>
            </div>

            {openTimeSlot && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      paddingLeft: "8px",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Select Date and Time
                  </div>

                  <Tabs
                    variant="fullWidth"
                    value={tabValue}
                    onChange={handleTabChange}
                  >
                    <Tab
                      label="Calendar"
                      value="calendar"
                      sx={{
                        "&.Mui-selected": {
                          color: theme.palette.mode === 'dark' ? "#fff !important" : "#121212 !important",
                        }
                      }}
                    ></Tab>
                    <Tab
                      label="Time"
                      value="time"
                      sx={{
                        "&.Mui-selected": {
                          color: theme.palette.mode === 'dark' ? "#fff !important" : "#121212 !important",
                        }
                      }}
                    ></Tab>
                  </Tabs>
                  {tabValue === "calendar" && (
                    <StaticDateTimePicker
                      displayStaticWrapperAs="desktop"
                      value={selectedDate}
                      sx={{
                        "& .MuiPickersArrowSwitcher-button": {
                          width: "auto",
                        },
                        "& .MuiPickersArrowSwitcher-root": {
                          width: "auto",
                        },
                        "& .MuiPickersCalendarHeader-switchViewButton": {
                          width: "auto",
                        },
                        "& .MuiPickersCalendarHeader-root": {
                          width: "auto",
                        },
                      }}
                      onChange={handleDateChange}
                      views={["year", "month", "day"]}
                    />
                  )}

                  {tabValue === "time" && (
                    <StaticDateTimePicker
                      displayStaticWrapperAs="desktop"
                      value={selectedDate}
                      sx={{
                        "& .MuiPickersArrowSwitcher-button": {
                          width: "auto",
                        },
                        "& .MuiPickersArrowSwitcher-root": {
                          width: "auto",
                        },
                      }}
                      onChange={(val) => setSelectedTime(val)}
                      views={["hours", "minutes"]}
                    />
                  )}

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      style={{
                        width: "fit-content",
                        display: "flex",
                        justifyContent: "center",
                        background: theme.palette.mode === 'dark' ? "#6c757d9c" : "#ededed",
                        padding: "4px 16px",
                        fontSize: "18px",
                        /* margin-top: 16px; */
                        fontWeight: "600",
                        borderRadius: "10px",
                      }}
                    >
                      {selectedDate?.format("DD-MM-YYYY HH:mm A")}
                    </div>
                  </div>
                </Box>
              </LocalizationProvider>
            )}
          </div>
        </div>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: theme.palette.mode === 'dark' ? "#121212" : "#fff",
          padding: "12px",
        }}
      >
        {(
          <div style={{ color: "green", textAlign: "center" }}>
            <p style={{ fontSize: "14px" }}>{message}</p>
          </div>
        )}
        <div
          style={{
            display: "flex",
            gap: "16px",
          }}
        >
          {openTimeSlot ? (
            <button
              className="btn btn-success"
              style={{
                borderRadius: "50px",
                width: "fit-content",
                fontSize: "12px",
                display: "flex",
                gap: "4px",
                alignItems: "center",
                padding: "8px 16px",
              }}
              onClick={handleScheduleCall}
            >
              <div style={{ width: "21px" }}>
                <i
                  style={{ fontSize: "14px" }}
                  className="bi bi-calendar-check"
                ></i>
              </div>
              Schedule Now
            </button>
          ) : (
            <button
              className="btn btn-success"
              style={{
                borderRadius: "50px",
                width: "fit-content",
                fontSize: "12px",
                display: "flex",
                gap: "4px",
                alignItems: "center",
                padding: "8px 16px",
              }}
              onClick={handleCallMe}
            >
              <div style={{ width: "21px" }}>
                <i
                  style={{ fontSize: "14px" }}
                  className="bi bi-telephone-fill"
                ></i>
              </div>
              Call Me
            </button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CallMe;
